<template>
    <v-container fluid>
        <SaralaTable
            :model="model"
            :resourceName="$tc('resources.landingPage.name', 2)"
            :createRoute="{ name: 'landingPage.create' }"
        />
    </v-container>
</template>

<script>
import LandingPage from '@/models/LandingPage'
import SaralaTable from '@/shared/components/SaralaTable'

export default {
    components: {
        SaralaTable,
    },

    computed: {
        model() {
            return new LandingPage()
        },
    },
}
</script>

<style></style>
